import React, { useContext, useRef } from 'react'
import styles from "../css/NoteCard.module.css"
import { colors_dict, light_colors } from '../../../data/colorsDict';
import { OverflowList } from "react-responsive-overflow-list";
import { useTimeAgo } from '../../../hooks/useTimeAgo';
import { IoEllipsisHorizontalSharp } from 'react-icons/io5';
import NoteMenu from './NoteMenu';
import { PageContext } from './Notes';
import { toast } from 'react-toastify';

const NoteCard = ({note}) => {
    const updateDate = useTimeAgo(note?.updatedAt)
    const menuBtn = useRef(null)
    const [pageModals,setPageModals] = useContext(PageContext)

    const handleMenu = () => {
        setPageModals((prevState)=>{
            let copy = {...prevState}
            if (copy.menu === null){
                copy.menu = note._id
                toast.dismiss()
            }
            else{
                copy.menu = null
            }
            return copy
        })
    }

    return (
        <div data-testid = {`note-card-${note._id}`} className={styles.noteCard}>
            <div className={`${styles.noteInner} ${pageModals.menu === note._id ? styles.openMenu : ""}`} style={{ "--hover-color": colors_dict[note.color] }}>
                <div data-testid = "note-color-bar" className={styles.noteCardBar} style = {{ backgroundColor: colors_dict[note.color]}}></div>
                <div className={styles.noteCardBody}>
                    <div className={styles.noteCardTitle}>{note.title}</div>
                    <div className = {styles.noteCardPreview} dangerouslySetInnerHTML={{ __html: note.content }} style={{ '--color-light': light_colors[note.color], '--color-default': colors_dict[note.color] }}/>
                    {note.tags.length > 0 && <div className={styles.noteCardTags}>
                            <OverflowList
                                items={note.tags}
                                renderItem={(tag) => (
                                    <span
                                        data-testid = {`tag-${tag._id}`}
                                        key={tag._id}
                                        className={styles.noteCardTag}
                                        style={{
                                            backgroundColor: light_colors[note.color],
                                            color: colors_dict[note.color],
                                        }}
                                    >
                                        {tag.name}
                                    </span>
                                )}
                                renderOverflow={(items) => (
                                    <span
                                        className={styles.noteCardTag}
                                        style={{
                                            backgroundColor: light_colors[note.color],
                                            color: colors_dict[note.color],
                                        }}
                                    >
                                        +{items.length}
                                    </span>
                                )}
                                maxRows={1}
                            />
                    </div>}
                </div>
                <div className={styles.noteCardFooter}>
                    <span className={styles.noteCardTime}>{updateDate}</span>
                    <button 
                        data-testid = "note-btn"
                        ref = {menuBtn} 
                        type = "button" 
                        className = {`${styles.noteCardMenu} ${pageModals.menu === note._id ? styles.active : ""}`} 
                        onClick={() => handleMenu()}
                    >
                        <IoEllipsisHorizontalSharp/>
                    </button>
                </div>
            </div>
            {pageModals.menu === note._id && <NoteMenu ref = {menuBtn} id = {note._id} closeMenu = {()=>handleMenu()}/>}
        </div>
  )
}

export default NoteCard